export const getCurrentModal = state => state.pages.common.currentModal
export const getCurrentModalArgs = state => state.pages.common.currentModalArgs
export const getPathname = state => state.routing.locationBeforeTransitions.pathname



/** WEBPACK FOOTER **
 ** ./src/selectors/common/common-selectors.js
 **/